// extracted by mini-css-extract-plugin
var _1 = "ra-basket-summary";
var _2 = "ra-basket-summary-count";
var _3 = "ra-basket-summary-details";
var _4 = "ra-basket-summary-header";
var _5 = "ra-basket-summary-item";
var _6 = "ra-basket-summary-items";
export { _1 as "basketSummaryCls", _2 as "basketSummaryCountCls", _3 as "basketSummaryFooterCls", _4 as "basketSummaryHeaderCls", _5 as "basketSummaryItemCls", _6 as "basketSummaryItemsCls" }
